import { Translate } from 'react-redux-i18n'
import { DefaultVsicName } from '../../../../../DefaultVsicName'
import { Content } from './Content'
import { ShowAllIndustry } from './ShowAllIndustry'

export const ChartGrowthRate = () => {
  return (
    <div className="h50 flexColumn">
      <div className="dFlex justifyContentBetween">
        <div>
          <Translate
            value="industryOverview.macroeconomics.IMPORT_EXPORT_GROWTH_RATE"
            className="fw600"
          />
          :
        </div>
        <ShowAllIndustry />
      </div>
      <DefaultVsicName />

      <div className="flex1">
        <Content />
      </div>

      <div
        style={{
          position: 'fixed',
          top: -1000,
          left: -2000,
          width: 1000,
          height: 600,
        }}
        id="macroImportExportGrowthRateId"
      >
        <Content />
      </div>
    </div>
  )
}
